import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { MockUserFull, mockCurrentUserVariants } from '@/data/mockPresets';
import { AuditTrailEntry, auditTrail4 } from '@/data/mocks/auditTrail';

// currentUser is the actual user for the current session,
// regardless of whether it was received from MockDataManager or the real backend
type EntityState = 'initial' | 'loading' | 'ok' | 'error' | 'forbidden';

interface AuditTrailMock {
  data: AuditTrailEntry[] | null;
  state: EntityState;
  error?: string;
}

interface MockDataState {
  currentUser: MockUserFull;
  auditTrail: AuditTrailMock;
}

const initialState: MockDataState = {
  currentUser: mockCurrentUserVariants.none,
  auditTrail: {
    data: auditTrail4,
    state: 'ok',
    error: undefined,
  },
};

const mockDataSlice = createSlice({
  name: 'mockData',
  initialState,
  reducers: {
    setCurrentUser: (state, action: PayloadAction<MockUserFull>) => {
      state.currentUser = action.payload;
    },
    setAuditTrailState: (state, action: PayloadAction<EntityState>) => {
      state.auditTrail.state = action.payload;
    },
    setAuditTrailData: (state, action: PayloadAction<AuditTrailEntry[]>) => {
      state.auditTrail.data = action.payload;
    },
    setAuditTrailError: (state, action: PayloadAction<string>) => {
      state.auditTrail.error = action.payload;
      state.auditTrail.state = 'error';
    },
  },
});

export const {
  setCurrentUser,
  setAuditTrailState,
  setAuditTrailData,
  setAuditTrailError,
} = mockDataSlice.actions;
export default mockDataSlice.reducer;

// Selectors
import type { RootState } from '../index';

export const selectCurrentUser = (state: RootState) =>
  state.mockData.currentUser;
export const selectAuditTrailMock = (state: RootState) =>
  state.mockData.auditTrail;
export const selectAuditTrailMockData = (state: RootState) =>
  state.mockData.auditTrail.data;
export const selectAuditTrailMockState = (state: RootState) =>
  state.mockData.auditTrail.state;
export const selectAuditTrailMockError = (state: RootState) =>
  state.mockData.auditTrail.error;


